import { CapacitorUpdater } from "@capgo/capacitor-updater"

export interface CapGoVersionInfo {
    builtinVersion: string
    deviceId: string
    channel: string
    latestVersion: string
    nextBundle: string
    pluginVersion: string
    currentVersion: string
    isAutoUpdateAvailable: boolean | string
    isAutoUpdateEnabled: boolean | string
}

export const getCapgoVersionInfo = async (): Promise<CapGoVersionInfo> => {
    const safeCall = async <T>(fn: () => Promise<T>): Promise<T | string> => {
        try {
            return await fn()
        } catch {
            return "-"
        }
    }

    const [
        builtinVersion,
        deviceId,
        channel,
        latestVersion,
        nextBundle,
        pluginVersion,
        currentVersion,
        isAutoUpdateAvailable,
        isAutoUpdateEnabled
    ] = await Promise.all([
        safeCall(async () => {
            const result = await CapacitorUpdater.getBuiltinVersion()
            return result.version
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.getDeviceId()
            return result.deviceId
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.getChannel()
            return `${result.channel},${result.status},${result.error},${result.message}`
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.getLatest()
            return result.version
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.getNextBundle()
            return result?.version || "-"
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.getPluginVersion()
            return result.version
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.current()
            return result.bundle.version
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.isAutoUpdateAvailable()
            return result.available
        }),
        safeCall(async () => {
            const result = await CapacitorUpdater.isAutoUpdateEnabled()
            return result.enabled
        })
    ])

    return {
        builtinVersion: builtinVersion,
        deviceId: deviceId,
        channel: channel,
        latestVersion: latestVersion,
        nextBundle: nextBundle,
        pluginVersion: pluginVersion,
        currentVersion: currentVersion,
        isAutoUpdateAvailable: isAutoUpdateAvailable,
        isAutoUpdateEnabled: isAutoUpdateEnabled
    }
}
